import ExternalDoorReplacementMeasurementValues from './ExternalDoorReplacementMeasurementValues';

export default ExternalDoorReplacementMeasurementValues ;